import React from 'react'
import Divider from 'antd/es/divider'

export default function FieldDivider(props) {
  /* Input Text
   * Expected Props:
   * className = <string> Optional
   * label = <string> Required
   * orientation = <string ["left", "right", "center"]> Optional
   * small = <boolean> Optional
   */

  return (
    <div className="form-divider">
      <Divider
        className={props.className}
        label={props.label}
        orientation={props.orientation}
        plain={props.small}
        children={props.label}
      />
      {props.help &&
        <small className="form-text text-muted custom-field-help">{props.help}</small>
      }
    </div>
  )
}
